import Cookie from 'js-cookie'
import utils from '@/assets/scripts/utilities.js'
import {
  SIGN_IN,
  SIGN_OUT,
  SET_USER_DATA,
  SET_RELEASE_NOTES,
  SET_ADV_MSGS,
} from '../mutation-types'
import { ENTER_SITE, EXIT_SITE } from '../action-types'

const user = {
  namespaced: true,
  state: {
    isAuthenticated: false,
    current: null,
    tokenExpirationMins: 0,
    sessionExpirationMins: 0,
    advisoryMessages: null,
    releaseNotes: null,
  },
  mutations: {
    [SIGN_IN](state) {
      state.isAuthenticated = true
      // Read Session related settings from a cookie.
      // Settings are stored in the DB
      const cookieId = utils.getCookieId()
      let sessionInfoCookie = Cookie.get(`gts_exp_info_${cookieId}`)
      if (sessionInfoCookie) {
        let arySessInfo = sessionInfoCookie.split('|')
        let tokenExpFromCookie = arySessInfo[0]
        let sessExpFromCookie = arySessInfo[1]
        state.tokenExpirationMins = utils.parseInt(tokenExpFromCookie)
        state.sessionExpirationMins = utils.parseInt(sessExpFromCookie)
      }
    },
    [SIGN_OUT](state, redirectURL) {
      $.ajax({
        url: `${AUTH_URL}/account/logout`,
        method: 'PUT',
        async: false,
      }).done(function () {
        state.isAuthenticated = false
        $(window).off('beforeunload')
        window.location.href = redirectURL || '/'
        // Trick that can help timing issues with data binding
        // Update: Not observed - commented out till further notice
        // setTimeout(() => {
        //   window.location.href = redirectURL || '/'
        // }, 0)
      })
    },
    [SET_USER_DATA](state, json) {
      state.current = json
    },
    [SET_RELEASE_NOTES](state, rn) {
      state.releaseNotes = rn
    },
    [SET_ADV_MSGS](state, amsgs) {
      state.advisoryMessages = amsgs
    },
  },
  actions: {
    [ENTER_SITE]({ commit }, payload) {
      commit(SET_USER_DATA, payload)
      commit(SIGN_IN)
    },
    [EXIT_SITE]({ commit }, payload) {
      commit(SIGN_OUT, payload)
    },
  },
  getters: {
    currentUser(state) {
      return state.current
    },
    clearingParticipants(state) {
      return state.current?.clearingParticipants
    },
    currentUserHighestRoleAcrossDTCC(state) {
      let _clearingParticipants = state.current.clearingParticipants

      if (_clearingParticipants.length > 1) {
        let _roleHierarchy = _clearingParticipants.map((cp) => cp.roleHierarchy)

        let clearingParticipantWithHighestRole = _clearingParticipants.find(
          (cp) => cp.roleHierarchy === Math.max(..._roleHierarchy),
        )

        return clearingParticipantWithHighestRole
      }

      return _clearingParticipants[0]
    },
    tasks(state) {
      return state.current?.tasks
    },
    getTokenExpirationMsecs(state) {
      return state.tokenExpirationMins * 60 * 1000
    },
    getSessionExpirationMsecs(state) {
      return state.sessionExpirationMins * 60 * 1000
    },
    latestReleasedVersion(state) {
      return state.releaseNotes ? state.releaseNotes[0].version : ''
    },
    loginAdvisoryMessage(state) {
      if (state.advisoryMessages && state.advisoryMessages.length > 0) {
        let _loginAdvMsg = state.advisoryMessages.find(
          (am) => am.categoryName === 'Login Advisory Message',
        )

        return _loginAdvMsg
          ? _loginAdvMsg.messageBody + _loginAdvMsg.messageBodyReadOnlyFooter
          : null
      }

      return null
    },
    pageSpecificMessages(state) {
      if (state.advisoryMessages && state.advisoryMessages.length > 0) {
        let pagesHash = {}

        state.advisoryMessages.forEach((am) => {
          if (am.availableAtRoute) {
            let _pages = am.availableAtRoute.split(',')

            _pages.forEach((p) => {
              if (pagesHash[p]) {
                pagesHash[p].push(am)
              } else {
                pagesHash[p] = []
                pagesHash[p].push(am)
              }
            })
          }
        })

        return pagesHash
      }

      return null
    },
  },
}

export default user
